// Only these backend boundaries explicitly accept independent admin assurance.
// Keep this policy independent of the WebAuthn client so native step-up never
// needs to load passkey runtime code for a customer operation.
const ADMIN_PASSKEY_CONSUMERS = new Set([
  "admin-api-keys",
  "admin-listing-stewardship",
  "admin-delete",
  "admin-passkey-access",
  "admin-mcp-access",
  "admin-scan-worker-operations",
  "admin-msp-management",
  "admin-resolve-onboarding-review",
]);

export function supportsAdminPasskeyFunction(name: unknown): boolean {
  return typeof name === "string" && ADMIN_PASSKEY_CONSUMERS.has(name);
}
